import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import {
  APIConfigMapping,
  HTTPAPIConfig,
  VlDataService,
  VlHttpService,
} from "shared-library";
import { Clipboard } from '@angular/cdk/clipboard';
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "lib-publish-app",
  templateUrl: "./publish-app.component.html",
  styleUrls: ["./publish-app.component.scss"],
})
export class webPublishAppComponent implements OnInit {
  publishStatus = false;
  spinnerActive = false;
  downLoadURL!: string;
  isPublished: boolean = false;
  spinnerMessage = "";
  constructor(
    public dialog: MatDialog,
    private dataService: VlDataService,
    private httpService: VlHttpService,
    private route: ActivatedRoute,
    private toasterService: ToastrService,
    private clipboard:Clipboard
  ) {}

  ngOnInit(): void {
    const currentParams = { ...this.route.snapshot.queryParams };
    this.checkPublishStatus(currentParams["id"]);
  }

  async checkPublishStatus(applicationId: string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(
      APIConfigMapping["ENABLE_PUBLISH"]
    );
    apiConfig.postData = { application_id: applicationId };

    await this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        this.publishStatus = data;
        this.spinnerActive = false;
        if (data) {
          this.publishApiCall(applicationId);
        } else {
          this.getApplicationUrl(applicationId);
        }
      },
      error: (err: any) => {
        this.spinnerActive = false;
      },
    });
  }

  publishApiCall(applicationId: string) {
    this.downLoadURL = "";
    this.spinnerActive = true;
    this.spinnerMessage = "Your app is being published , please wait";
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(
      APIConfigMapping["PUBLISH_APP"]
    );
    apiConfig.postData = { application_id: applicationId };
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        this.spinnerActive = false;
        this.isPublished = true;
        this.downLoadURL = data.application_url;
        this.toasterService.success("Published !!");
      },
      complete: () => {},
      error: (err: any) => {
        this.spinnerActive = false;
      },
    });
  }

  getApplicationUrl(applicationId: string) {
    this.downLoadURL = "";
    this.spinnerActive = true;
    this.spinnerMessage = "fetching apk url , please wait";
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(
      APIConfigMapping["WEB_APP_URL"]
    );
    apiConfig.postData = { application_id: applicationId };
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        this.spinnerActive = false;
        this.downLoadURL = data.response;
      },
      complete: () => {},
      error: (err: any) => {
        this.spinnerActive = false;
      },
    });
  }

  copyToClipboard(downLoadURL: string) {
    this.clipboard.copy(downLoadURL);
  }
}
